import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect } from "react";
import { graphScope } from "../auth-config";

export default function LoginPage() {
  const { instance, isAuthenticated } = useMsal();

  useEffect(() => {
    if (!isAuthenticated) {
      instance.loginRedirect(graphScope);
    }
  }, [isAuthenticated, instance]);

  return (
    <section className="flex flex-col items-center justify-center gap-4 py-8 md:py-10">
      <div className="inline-block max-w-lg text-center justify-center">
        {/* <Button>Login</Button> */}
      </div>
    </section>
  );
}
